import { render, staticRenderFns } from "./TheNavbar.vue?vue&type=template&id=5d135483&scoped=true"
import script from "./TheNavbar.vue?vue&type=script&lang=js"
export * from "./TheNavbar.vue?vue&type=script&lang=js"
import style0 from "./TheNavbar.vue?vue&type=style&index=0&id=5d135483&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d135483",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d135483')) {
      api.createRecord('5d135483', component.options)
    } else {
      api.reload('5d135483', component.options)
    }
    module.hot.accept("./TheNavbar.vue?vue&type=template&id=5d135483&scoped=true", function () {
      api.rerender('5d135483', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/utils/TheNavbar.vue"
export default component.exports